import { BookingCalendar } from "PFApp/booking/types";
import { Collection } from "PFTypes";
import { ExceptionDay, NominalDay } from "PFTypes/booking/booking_config";

import api from "../api";
import { fetchPaginatedCollection } from "../helpers/collection";
import { ApiRoute } from "../utilities/routes";

export const getCalendar = (id: string): Promise<BookingCalendar> =>
  api({
    url: `admin/booking_module/calendars/${id}`
  });

export const getCalendars = (
  page: number,
  perPage: number,
  term?: string
): Promise<Collection<BookingCalendar[]>> =>
  fetchPaginatedCollection(ApiRoute("/api/admin/booking_module/calendars"), {
    page,
    perPage,
    ...(term ? { term } : {})
  });

export const postCalendar = (calendarName: string, main: boolean): Promise<BookingCalendar> =>
  api({
    url: "admin/booking_module/calendars",
    method: "POST",
    data: {
      name: calendarName,
      main
    }
  });

export const updateCalendarName = (calendarId: number, calendarName: string): Promise<void> =>
  api({
    url: `admin/booking_module/calendars/${calendarId}`,
    method: "PUT",
    data: {
      name: calendarName
    }
  });

export const updateNominalDay = (nominalDay: Partial<NominalDay>): Promise<NominalDay> =>
  api({
    url: `admin/booking_module/nominal_days/${nominalDay.id}`,
    method: "PUT",
    data: nominalDay
  });

export const postExceptionDay = (data: ExceptionDay): Promise<ExceptionDay> =>
  api({
    url: "admin/booking_module/exception_days",
    method: "POST",
    data
  });

export const deleteExceptionDay = (calendarId: number, exceptionDayId: number): Promise<void> =>
  api({
    url: `admin/booking_module/exception_days/${exceptionDayId}`,
    method: "DELETE",
    data: { calendarId, id: exceptionDayId }
  });

export const updateExceptionDay = (data: ExceptionDay): Promise<ExceptionDay> =>
  api({
    url: `admin/booking_module/exception_days/${data.id}`,
    method: "PUT",
    data
  });

export const getCalendarExceptionDays = (id: string): Promise<Collection<ExceptionDay[]>> =>
  api({
    url: `admin/booking_module/exception_days`,
    params: {
      calendarId: id
    }
  });

export const getCalendarNominalDays = (id: string): Promise<Collection<NominalDay[]>> =>
  api({
    url: `admin/booking_module/nominal_days`,
    params: {
      calendarId: id
    }
  });
